"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addTopic = addTopic;
exports.batchDeleteTopic = batchDeleteTopic;
exports.deleteTopic = deleteTopic;
exports.getTopicInfo = getTopicInfo;
exports.getTopicList = getTopicList;
exports.updateTopic = updateTopic;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
// 分页查询社区-话题管理
function getTopicList(query) {
  return (0, _requestAuth.default)({
    url: '/xyCommunityTopic/page',
    method: 'get',
    params: query
  });
}

// 获取话题详情
function getTopicInfo(id) {
  return (0, _requestAuth.default)({
    url: "/xyCommunityTopic/".concat(id),
    method: 'get'
  });
}

// 新增话题
function addTopic(data) {
  return (0, _requestAuth.default)({
    url: '/xyCommunityTopic',
    method: 'post',
    data: data
  });
}

// 修改话题
function updateTopic(data) {
  return (0, _requestAuth.default)({
    url: '/xyCommunityTopic',
    method: 'put',
    data: data
  });
}

// 删除话题
function deleteTopic(id) {
  return (0, _requestAuth.default)({
    url: "/xyCommunityTopic/".concat(id),
    method: 'delete'
  });
}

// 批量删除话题
function batchDeleteTopic(ids) {
  return (0, _requestAuth.default)({
    url: '/xyCommunityTopic/batchDelete',
    method: 'post',
    data: ids
  });
}